/** state **/
const state = {
  crew : {},
  crews : [],
};

/** mutations **/
const mutations = {

};

/** actions **/
const actions = {

};

/** getters **/
const getters = {

};

/** export **/
export default {state, actions, mutations, getters};
